module.exports = __webpack_public_path__ + "assets/img/icon-intercom-iframe.a1ae89bc.svg";